import fechasBanner from '../../../../assets/fechas.webp';
import { resolvePendingChallengeUrl } from '../../infrastructure/challengeLinks';
import { Brand, Panel, primary, replayButton, secondary } from './ExperienceLayout';

const bannerAlt = 'Ñaca Ñaca 3ra Edición — Festival Internacional de Cine de Terror, del 02 al 04 de octubre';
const shareButton = 'min-h-[44px] border border-[#7EC54A]/60 bg-[#1A4D2E]/80 px-2 py-3 text-[10px] font-black uppercase tracking-wider text-white';

function FestivalBanner() {
  return <img src={fechasBanner} alt={bannerAlt} className="mx-auto h-auto w-[min(64vw,200px)] object-contain" />;
}

export function ChallengeSetupScreen({ challenge, error, loading, onCreate, onShare, onBegin, onBack }) {
  return (
    <Panel>
      <FestivalBanner />
      <p className="mt-8 text-[10px] font-black uppercase tracking-[.25em] text-[#F7E04B]">Duelo ceremonial</p>
      <h1 className="mt-2 font-display text-4xl uppercase leading-none text-white">Duelo entre<br />brujos</h1>
      <p className="mt-5 text-sm leading-6 text-[#C5E6A0]">Crea y comparte un vínculo único. Tu amigo tendrá 24 horas para jugar el reto.</p>
      {error && <p role="alert" className="mt-4 text-sm font-bold text-[#F7E04B]">{error}</p>}
      {!challenge ? (
        <button onClick={onCreate} disabled={loading} className={`${primary} mt-7 disabled:opacity-60`}>
          {loading ? 'Creando…' : 'Crear reto'}
        </button>
      ) : (
        <div className="mt-7 text-left">
          <p className="text-center text-[10px] font-black uppercase tracking-[.18em] text-[#F7E04B]">Comparte tu vínculo único</p>
          <p className="mt-2 text-center text-xs text-[#C5E6A0]">Vence en 24 horas.</p>
          <p className="mt-3 break-all border border-[#7EC54A]/60 bg-black/40 p-3 text-xs text-[#F7E04B]">{challenge.url}</p>
          <div className="mt-3 grid grid-cols-3 gap-2">
            <button onClick={() => onShare('whatsapp')} className={shareButton}>WhatsApp</button>
            <button onClick={() => onShare('messenger')} className={shareButton}>Messenger</button>
            <button onClick={() => onShare('copy')} className={shareButton}>Copiar link</button>
          </div>
          {challenge.shared ? (
            <button onClick={onBegin} className={`${replayButton} mt-4`}>Comenzar reto</button>
          ) : (
            <p className="mt-4 text-center text-xs font-bold text-[#C5E6A0]">Comparte o copia el vínculo para desbloquear el juego.</p>
          )}
        </div>
      )}
      <button onClick={onBack} className="mt-6 text-xs font-bold uppercase tracking-widest text-[#F7E04B] underline underline-offset-4">Volver al mapa</button>
    </Panel>
  );
}

export function ChallengeInviteScreen({ invite, gps, error, loading, onLocate, onBegin, onBack }) {
  return (
    <Panel>
      <Brand compact centered />
      <p className="mt-8 text-[10px] font-black uppercase tracking-[.25em] text-[#F7E04B]">Invitación de duelo</p>
      <h1 className="mt-2 font-display text-4xl uppercase leading-none text-white">
        {invite ? `@${invite.creator.username} te reta` : 'Preparando el reto'}
      </h1>
      <p className="mt-5 text-sm leading-6 text-[#C5E6A0]">Puedes jugar el reto sin GPS. Tu partida contará, aunque algunas medallas de ubicación no podrán acreditarse.</p>
      {gps?.status !== 'inside' && (
        <button
          type="button"
          onClick={() => onLocate?.()}
          disabled={gps?.status === 'locating'}
          className="mt-4 min-h-[44px] w-full text-xs font-bold uppercase tracking-wider text-[#F7E04B] underline underline-offset-4 disabled:opacity-60"
        >
          {gps?.status === 'locating' ? 'Localizando…' : 'Activar GPS para medallas'}
        </button>
      )}
      {error && <p role="alert" className="mt-4 text-sm font-bold text-[#F7E04B]">{error}</p>}
      <button type="button" onClick={onBegin} disabled={!invite || loading} className={`${replayButton} mt-7 disabled:opacity-60`}>
        {loading ? 'Preparando…' : 'Comenzar reto'}
      </button>
      <button onClick={onBack} className="mt-6 text-xs font-bold uppercase tracking-widest text-[#F7E04B] underline underline-offset-4">Volver al mapa</button>
    </Panel>
  );
}

const statusLabels = {
  open: 'Esperando rival',
  claimed: 'En curso',
  completed: 'Finalizado',
  expired: 'Vencido',
  cancelled: 'Cancelado',
};

function ChallengeScore({ item }) {
  const creatorScore = item.creator.score;
  const opponentScore = item.opponent?.score;
  if (creatorScore == null || opponentScore == null) {
    return <p className="mt-2 text-xs text-[#C5E6A0]">{creatorScore ?? '—'} / {opponentScore ?? '—'} puntos de juego</p>;
  }
  if (creatorScore === opponentScore) {
    return (
      <div className="mt-3">
        <p className="text-base font-black uppercase tracking-wide text-white">Empate · {creatorScore} puntos</p>
        <p className="mt-1 text-xs text-[#C5E6A0]">@{item.creator.username} · {creatorScore} puntos · @{item.opponent?.username} · {opponentScore} puntos</p>
      </div>
    );
  }
  const creatorWins = creatorScore > opponentScore;
  const winnerName = creatorWins ? item.creator.username : item.opponent?.username;
  const winnerScore = creatorWins ? creatorScore : opponentScore;
  const loserName = creatorWins ? item.opponent?.username : item.creator.username;
  const loserScore = creatorWins ? opponentScore : creatorScore;
  return (
    <div className="mt-3">
      <p className="text-base font-black uppercase tracking-wide text-white">Ganador @{winnerName} · {winnerScore} puntos</p>
      <p className="mt-1 text-xs text-[#C5E6A0]">@{loserName} · {loserScore} puntos</p>
    </div>
  );
}

function PendingChallengeLink({ item, url, onShare, isCopied }) {
  return (
    <div className="mt-3 border border-[#7EC54A]/60 bg-black/40 p-3">
      <p className="text-[10px] font-black uppercase tracking-[.18em] text-[#F7E04B]">Tu vínculo pendiente</p>
      <p className="mt-2 break-all text-xs text-[#F7E04B]">{url}</p>
      <div className="mt-3 grid grid-cols-3 gap-2">
        <button type="button" onClick={() => onShare(item, 'whatsapp')} className={shareButton}>WhatsApp</button>
        <button type="button" onClick={() => onShare(item, 'messenger')} className={shareButton}>Messenger</button>
        <button type="button" onClick={() => onShare(item, 'copy')} className={shareButton}>
          {isCopied ? '¡Copiado!' : 'Copiar link'}
        </button>
      </div>
    </div>
  );
}

function ChallengeItem({ item, onPlay, onShare, copiedChallengeId }) {
  const isPending = item.status === 'open' || item.status === 'claimed';
  const waitingRival = item.myScore != null || !item.opponent || item.status === 'open';
  const showPlayButton = item.canPlay && !waitingRival;
  const pendingUrl = item.status === 'open' ? resolvePendingChallengeUrl(item) : null;
  return (
    <div className={isPending ? 'mb-3 rounded-sm border border-[#7C3AED]/50 bg-[#7C3AED]/15 px-3 py-4' : 'border-b border-[#7EC54A]/35 py-4'}>
      <div className="flex items-center justify-between gap-3">
        <span className="font-bold text-white">@{item.creator.username} vs {item.opponent ? `@${item.opponent.username}` : 'pendiente'}</span>
        <span className="text-[10px] font-black uppercase text-[#F7E04B]">{statusLabels[item.status] || item.status}</span>
      </div>
      <ChallengeScore item={item} />
      <p className="mt-1 text-xs text-[#C5E6A0]">
        {item.rewarded ? 'premios acreditados' : item.status === 'completed' ? 'sin premio (pareja repetida)' : 'resultado pendiente'}
      </p>
      <p className="mt-2 text-xs text-[#C5E6A0]">
        {item.myScore != null
          ? `Tu puntaje está guardado: ${item.myScore}.`
          : item.canPlay
            ? 'Te falta jugar. Termina la partida, ganes o pierdas, para guardar tu puntaje.'
            : 'Sin partida registrada.'}
      </p>
      {showPlayButton && (
        <button type="button" onClick={() => onPlay(item)} className={`${primary} mt-3`}>Jugar este reto</button>
      )}
      {pendingUrl && (
        <PendingChallengeLink
          item={item}
          url={pendingUrl}
          onShare={onShare}
          isCopied={copiedChallengeId === item.id}
        />
      )}
    </div>
  );
}

export function PendingChallengesScreen({
  items, cursor, error, loading, onPlay, onShare, copiedChallengeId, onLoadMore, onBack,
}) {
  return (
    <Panel wide>
      <FestivalBanner />
      <p className="mt-7 text-[10px] font-black uppercase tracking-[.25em] text-[#F7E04B]">Tus Duelos</p>
      <h1 className="mt-2 break-words font-display text-[1.8rem] uppercase leading-[1.05] text-white">Enfrentamientos</h1>
      {error && <p role="alert" className="mt-4 text-sm font-bold text-[#F7E04B]">{error}</p>}
      <div className="mt-6 text-left">
        {loading && !items.length ? (
          <p className="py-10 text-center text-sm text-white">Cargando retos…</p>
        ) : items.length ? (
          items.map((item) => (
            <ChallengeItem
              key={item.id}
              item={item}
              onPlay={onPlay}
              onShare={onShare}
              copiedChallengeId={copiedChallengeId}
            />
          ))
        ) : (
          <p className="py-10 text-center text-sm text-white">No tienes retos todavía.</p>
        )}
      </div>
      {cursor && (
        <button type="button" disabled={loading} onClick={onLoadMore} className={`${secondary} mt-4`}>
          {loading ? 'Cargando…' : 'Ver más retos'}
        </button>
      )}
      <button onClick={onBack} className={`${secondary} mt-7`}>Volver al mapa</button>
    </Panel>
  );
}
